import { createOpowerWidget } from '../utils/createOpowerWaytoSaveWidget';

const MyPricingPlanWidget = createOpowerWidget('opower-widget-rates');

export default MyPricingPlanWidget;
